import ProductRatingInlineProvider from './hooks/useProductRatingInline';

import ProductRatingInlineContainer from './handles/ProductRatingInlineContainer';

const ProductRatingInline = (props: any) => (
	<ProductRatingInlineProvider>
		<ProductRatingInlineContainer {...props} />
	</ProductRatingInlineProvider>
);

export default ProductRatingInline;
